import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './CategoryItem.css';
import { ICategory } from '../../../../types/promosPage';

interface ICategoryItemProps {
  category: ICategory;
  onClick?(category: ICategory): void;
}

export const CategoryItem: React.FC<ICategoryItemProps> = ({ category, onClick }) => {
  const handleClick = React.useCallback(() => {
    if (onClick) {
      onClick(category);
    }
  }, [category, onClick]);

  return (
    <a className={styles['link']} href={category.url} onClick={handleClick} data-testid="CategoryItem">
      <div className={styles['content']}>
        <UIText1>{category.name}</UIText1>
        <IconActionChevronRight16 />
      </div>
    </a>
  );
};
